import * as React from 'react';
import {styled, useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import ProfileMenu from "../../../menu/ProfileMenu";
import {makeStyles} from "@material-ui/core/styles";
import SLogo from "../../../../assets/images/SLogo.png";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useContext, useState} from "react";
import {useHistory} from "react-router-dom";
import UserContext from "../../../../context/UserContext";
import {Collapse, MenuItem} from "@material-ui/core";
import {SidebarMenuItems} from './menuItems';
import { hasChildren } from "./utils";
import SancorS from "../../../../assets/images/SancorS.png";
import Tooltip from "@mui/material/Tooltip";

const drawerWidth = 240;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(9)} + 1px)`,
    },
});

const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 2),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({theme, open}) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, {shouldForwardProp: (prop) => prop !== 'open'})(
    ({theme, open}) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

const useStyles = makeStyles((theme) => ({
    nombreMenu: {
        fontSize: '16px',
        color: '#f3f4f8',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
    },
    imagenPerfil: {
        width: '48px', height: '48px', borderRadius: '50%',
        border: '2px solid #fff',
        margin: '0 10px',
        [theme.breakpoints.down('md')]: {
            margin: 0
        },
    },
    sancorLogo: {
        width: " auto",
        height: "50px",
    },
    sancorLogoS: {
        width: " auto",
        height: "32px",
    },
    navBar: {
        position: "relative",
        backgroundColor: "#004285",
        clippath: "polygon(0 0, 100% 0, 100% 70px, 0 70px)",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        height: "70px",
    },
    navBarUserInfo: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        marginRight: "20px",
        width: "100%",
    },
    navBarUserInfoDivider: {
        transform: "rotate(90deg)",
        color: "#fff",
        display: "flex",
        flexDirection: "row",
        alignItems: "center"
    },
    navBarUserInfoNameRole: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "self-end"
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        //this will hide the backdrop when varient="temporary"
        "& .MuiBackdrop-root": {
            display: "none"
        }
        //backgroundColor: "rgba(0,0,0,0.6)" Don't target this
    },
    drawerPaper: {
        width: "240px   ",
        backgroundColor: "rgba(120,120,120,0.2)"
    },
    drawerHeader: {
        backgroundColor: "#4C5782"
    },
    toolbar: {
        backgroundColor: "#3D4977"
    },
    itemList: {
        margin:"4px 0px",
        '&:hover': {
            borderRadius:"0px 30px 30px 0px",
        },
    }
}));

export default function AdviserSideNavBar(props) {

    const {open, togleSideNav, userName, userPicture} = useContext(UserContext);
    const role = props.role;
    const history = useHistory();
    const classes = useStyles();
    const theme = useTheme();
    const handleDrawerOpen = () => {
        togleSideNav();
    };
    const handleDrawerClose = () => {
        togleSideNav();
    };

    const MenuItem = ({ item }) => {
        const Component = hasChildren(item) ? MultiLevel : SingleLevel;
        return <Component item={item} />;
    };

    const SingleLevel = ({ item }) => {
        const handleItemClick = (idx) =>{
            switch (idx){
                case 0:
                    history.push("/u/dashboard");
                    break;
                case 1.1:
                    history.push("/u/cotizar/vehiculo");
                    break;
                case 1.2:
                    history.push("/u/cotizar/motovehiculo");
                    break;
                case 1.3:
                    history.push("/u/cotizar/combinado");
                    break;
                case 1.4:
                    history.push("/u/cotizar/microseguro");
                    break;
                case 2.1:
                    history.push({
                            pathname: 'documentacion/' + 'vehiculo',
                            state: {
                                producto: 'vehiculo'
                            }
                        })
                    break;
                case 2.2:
                    history.push({
                        pathname: 'documentacion/' + 'motovehiculo',
                        state: {
                            producto: 'motovehiculo'
                        }
                    })
                    break;
                case 2.3:
                    history.push({
                        pathname: 'documentacion/' + 'hogar',
                        state: {
                            producto: 'combinado'
                        }
                    })
                    break;
                case 2.4:
                    history.push({
                        pathname: 'documentacion/' + 'microseguro',
                        state: {
                            producto: 'microseguro'
                            }
                    }) 
                    break;
                case 2.5:
                    history.push({
                        pathname: 'documentacion/' + 'otros',
                        state: {
                            producto: 'otros'
                        }
                    })
                    break;
                case 2.6:
                    history.push({
                        pathname: 'documentacion/' + 'prevencion',
                        state: {
                            producto: 'prevencion'
                        }
                    })
                    break;
            }
        }

        return (
            <ListItem button onClick={() => handleItemClick(item.index)} className={classes.itemList}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.title} />
            </ListItem>
        );
    };

    const MultiLevel = ({ item }) => {
        const { items: children } = item;

        const [open, setOpen] = useState(false);

        const handleClick = (e) => {
            setOpen((prev) => !prev);
        };

        return (
            <React.Fragment>
                <ListItem button onClick={handleClick} className={classes.itemList}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.title} />
                    {open ? <ExpandLessIcon style={{color: "#3D4977"}}/> : <ExpandMoreIcon style={{color: "#3D4977"}}/>}
                </ListItem>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding style={{paddingLeft:"16px"}}>
                        {children.map((child, key) => (
                            <MenuItem key={key} item={child} />
                        ))}
                    </List>
                </Collapse>
            </React.Fragment>
        );
    };

    return (
        <Box sx={{display: 'flex'}}>
            <CssBaseline/>
            <AppBar position="fixed" open={open}>
                <Toolbar className={classes.toolbar} >
                    <img
                        className={classes.sancorLogoS}
                        src={SancorS}
                        alt="SLogo"
                        hidden={open}
                        style={{ marginRight:"16px", marginLeft:"-8px",}}
                    />
                    <Divider orientation="vertical" flexItem style={{margin:"0px 16px 0px 8px"}} hidden={open}/>
                    <Tooltip title="Expandir" placement="right" hidden={open}>
                        <IconButton
                            color="inherit"
                            style={{color: "#fff", display: open && "none"}}
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                        >
                            <MenuIcon/>
                        </IconButton>
                    </Tooltip>
                    <div className={classes.navBarUserInfo}>
                        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <NotificationsNoneIcon style={{fill: "#fff"}}/>
                        </div>
                        <div className={classes.navBarUserInfoDivider}>
                            <HorizontalRuleIcon/>
                        </div>

                        <div className={classes.navBarUserInfoNameRole}>
                            <p className="adviser-name">{userName}</p>
                            <p className="adviser-position" style={{marginTop: "0px"}}>{role}</p>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                            <ProfileMenu
                                userImg={userPicture}/>
                        </div>
                    </div>
                </Toolbar>
            </AppBar>
            <Drawer
                variant="permanent"
                open={open}
            >
                <DrawerHeader className={classes.drawerHeader}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        justifyContent: "space-between",
                    }}>
                        <img
                            className={classes.sancorLogo}
                            src={SLogo}
                            alt="SLogo"
                        />
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'rtl' ? <ChevronRightIcon style={{color:"#fff"}}/> : <ChevronLeftIcon style={{color:"#fff"}}/>}
                        </IconButton>
                    </div>
                </DrawerHeader>
                <Divider/>

                {SidebarMenuItems().map((item, key) => <MenuItem key={key} item={item} />)}

            </Drawer>
        </Box>
    );
}